// extracted by mini-css-extract-plugin
module.exports = {"paypal_modal__content_container":"modal-content-module--paypal_modal__content_container--D_lqA","paypal_modal__content":"modal-content-module--paypal_modal__content--2mYM3"};